import { cn } from '@repo/tailwind-config/tailwind.functions'
import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import Badge from '@repo/ui/badge'
import InnerBox from '@repo/ui/inner-box'
import Typography from '@repo/ui/typography'

type Props = {
  total: number
  placed: number
  notPlaced: number
  className?: string
}

const PlacementSummary = ({ total, placed, notPlaced, className }: Props) => {
  return (
    <InnerBox className="p-1 rounded-sm w-fit">
      <div className={cn('flex flex-col items-center gap-1', className)}>
        <Typography variant="label-semibold" color={tailwindColors.grey.DEFAULT}>
          {total}
        </Typography>
        <Badge text={`Placés : ${placed}`} variant="success" />
        <Badge text={`Non placés : ${notPlaced}`} variant="danger" />
      </div>
    </InnerBox>
  )
}

export default PlacementSummary
